import React, {Component} from "react";
import app_cs from "./map.module.css";
import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {ScrollToPlugin} from 'gsap/ScrollToPlugin';
import $ from 'jquery'
import img_agriculture from 'assets/images/pc/img_agriculture.png'
import img_gas from 'assets/images/pc/img_gas.png'
import img_nuclear from 'assets/images/pc/img_nuclear.png'
import img_money from 'assets/images/pc/img_money.png'
import icon_gas from 'assets/images/pc/icon_gas.png'
import icon_nuclear from 'assets/images/pc/icon_nuclear.png'
import icon_money from 'assets/images/pc/icon_money.png'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

class App extends Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {
        let _self =this;

        let _t_history= gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_history_wrapper'],
                start: "top top", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'+=10000',
                pin:true,
                anticipatePin: 1,
                fastScrollEnd:true,
                preventOverlaps:true,
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                // markers:true,
                onToggle: self => {
                    if(self.isActive){
                        _self.props.changeYear(0)
                    }
                    else{
                        _self.props.changeYear(null)
                    }
                }
            }
        });

        _t_history.to('.'+app_cs['background-image-history'],{opacity:1,duration:0})
            .to('.'+app_cs['content_history_middle_text'],{opacity:0,duration:2},'<')
            .to('.'+app_cs['content_history_para'], {opacity:1,duration:2})
            /*info1*/
            .to('.'+app_cs['content_history_para1']+' .'+app_cs['content_history_para_mark'], {
                background:'#CD5C28',
                duration:2,
            })
            .to('.'+app_cs['content_history_middle_info1'],{opacity:1,duration:2},'<')
            .to('.'+app_cs['content_history_middle_arrow1'],{opacity:1,duration:2},)

            /*info1*/
            /*info2*/
            .to('.'+app_cs['content_history_para1']+' .'+app_cs['content_history_para_mark'], {
                background:'#8F8F8F',
                duration:1,
            })
            .to('.'+app_cs['content_history_middle_info1'],{opacity:0,duration:1},'<')
            .to('.'+app_cs['content_history_middle_arrow1'],{opacity:0,duration:1},"<")
            .to('.'+app_cs['content_history_para2']+' .'+app_cs['content_history_para_mark'], {
                background:'#CD5C28',
                duration:2,
            })
            .to('.'+app_cs['content_history_middle_info2'],{opacity:1,duration:2},'<')
            .to('.'+app_cs['content_history_middle_arrow2'],{opacity:1,duration:2},)
            /*info2*/
            /*info3*/
            .to('.'+app_cs['content_history_para2']+' .'+app_cs['content_history_para_mark'], {
                background:'#8F8F8F',
                duration:1,
            })
            .to('.'+app_cs['content_history_middle_info2'],{opacity:0,duration:1},'<')
            .to('.'+app_cs['content_history_middle_arrow2'],{opacity:0,duration:1},"<")
            .to('.'+app_cs['content_history_para3']+' .'+app_cs['content_history_para_mark'], {
                background:'#CD5C28',
                duration:2,
            })
            .to('.'+app_cs['content_history_middle_info3'],{opacity:1,duration:2},'<')
            /*info3*/
            /*info4*/
            .to('.'+app_cs['content_history_para3']+' .'+app_cs['content_history_para_mark'], {
                background:'#8F8F8F',
                duration:1,
            })
            .to('.'+app_cs['content_history_middle_info3'],{opacity:0,duration:1},'<')
            .to('.'+app_cs['content_history_para4']+' .'+app_cs['content_history_para_mark'], {
                background:'#CD5C28',
                duration:2,
            })
            .to('.'+app_cs['content_history_middle_info4'],{opacity:1,duration:2},'<')
            /*info4*/
            .to('.'+app_cs['content_history_middle_info4'],{opacity:0,duration:1},)
        .to('.'+app_cs['content_history_para'], {opacity:0,duration:1})
        .to('.'+app_cs['background-image-history'],{opacity:0,duration:1},"<")


        let t_start = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['info'],
                pin: "."+app_cs['background'],   // pin the trigger element while active
                start: "top top", // when the top of the trigger hits the top of the viewport
                end:'bottom bottom',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                anticipatePin: 1,
                // markers:true,
                fastScrollEnd:true,
                preventOverlaps:true,
            }
        });


        let t1991 = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_time_wrapper_1'],
                endTrigger:"."+app_cs['content_para_1991_4'],
                pin: "."+app_cs['content_time_wrapper_1'],   // pin the trigger element while active
                start: "top top", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'top top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                // markers:true,
                fastScrollEnd:true,
                preventOverlaps:true,
                onToggle: self => {
                    if(self.isActive){
                        _self.props.changeYear(1)
                    }
                    else{
                        _self.props.changeYear(null)
                    }
                }
            }
        });



        let t1991_ =  gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_para_1991'],
                endTrigger:"."+app_cs['content_para_1991_4'],
                start: "top bottom", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'top top',
                fastScrollEnd:true,
                preventOverlaps:true,
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar

            }
        });
        t1991_ .to('.'+app_cs['background-image-1991-1'],{opacity:1,duration:2})
            .to('.'+app_cs['background-image-1991-1'],{opacity:0,duration:1})
            .to('.'+app_cs['background-image-1991-2'],{opacity:1,duration:2},"<")
            .to('.'+app_cs['background-image-1991-3'],{opacity:1,duration:2})
            .to('.'+app_cs['background-image-1991-2'],{opacity:0,duration:0})
            .to('.'+app_cs['background-image-1991-4'],{opacity:1,duration:2})
            .to('.'+app_cs['background-image-1991-3'],{opacity:0,duration:1})
        ;

        let t1994 = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_time_wrapper_2'],
                start: "top top", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'bottom top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                // markers:true,
                fastScrollEnd:true,
                preventOverlaps:true,
                onToggle: self => {
                    if(self.isActive){
                        _self.props.changeYear(2)
                    }
                    else{
                        _self.props.changeYear(null)
                    }
                }
            }
        });


        let _t1994_1999 = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_para_1994'],
                start: "top bottom", // when the top of the trigger hits the top of the viewport
                endTrigger:"."+app_cs['content_para_1999'],
                // end:'bottom top+=60.45%',
                end:'top top',
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                fastScrollEnd:true,
                preventOverlaps:true,
            }
        });

        _t1994_1999.to('.'+app_cs['background-image-1991-4'],{opacity:0,duration:1})
            .to('.'+app_cs['background-image-1999-1'],{opacity:1,duration:2},"<")
            .to('.'+app_cs['background-image-1999-font'],{opacity:1,duration:2},"<")
            .to('.'+app_cs['background-image-1999-font'],{opacity:0,duration:0},)
            .to('.'+app_cs['background-image-1999-1'],{scale:1.6,opacity:1,duration:2},"<")
            .to('.'+app_cs['background-image-1999-2'],{opacity:1,duration:2})
            .to('.'+app_cs['background-image-1999-1'],{scale:1.6,opacity:0,duration:0});

        let t1999= gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_time_wrapper_3'],
                endTrigger:"."+app_cs['content_para_1999_2'],
                pin: "."+app_cs['content_time_wrapper_3'],   // pin the trigger element while active
                start: "top top", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'top top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                // markers:true,
                fastScrollEnd:true,
                preventOverlaps:true,
                onToggle: self => {
                    if(self.isActive){
                        _self.props.changeYear(3)
                    }
                    else{
                        _self.props.changeYear(null)
                    }
                }
            }
        });
        t1999.to('.'+app_cs['content_pic_1999'],{opacity:0,duration:1})
            .to('.'+app_cs['content_pic_1999'],{opacity:1,duration:1});


        let t2004 = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_time_wrapper_4'],
                start: "top top", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'bottom top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                // markers:true,
                fastScrollEnd:true,
                preventOverlaps:true,
                onToggle: self => {
                    if(self.isActive){
                        _self.props.changeYear(4)
                    }
                    else{
                        _self.props.changeYear(null)
                    }
                }
            }
        });

        let t2004_ =  gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_para_1999_2'],
                start: "top top-=10%", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                endTrigger: "."+app_cs['content_para_2004'],
                end:'top top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                fastScrollEnd:true,
                preventOverlaps:true,
            }
        });
        t2004_.to('.'+app_cs['background-image-2004-1'],{opacity:1,duration:2})
            .to('.'+app_cs['background-image-1999-2'],{opacity:0,duration:0});

        let t2008 = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_time_wrapper_5'],
                start: "top top+=1px", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'bottom top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                // markers:true,
                fastScrollEnd:true,
                preventOverlaps:true,
                onToggle: self => {
                    if(self.isActive){
                        _self.props.changeYear(5)
                    }
                    else{
                        _self.props.changeYear(null)
                    }
                }
            }
        });

        let t2008_ =  gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_para_2008'],
                start: "top bottom", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'top top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                fastScrollEnd:true,
                preventOverlaps:true,
            }
        });
        t2008_.to('.'+app_cs['background-image-2008-1'],{opacity:1,duration:2})
            .to('.'+app_cs['background-image-2004-1'],{opacity:0,duration:0},);

        let t2009 = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_time_wrapper_6'],
                start: "top top", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'bottom top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                // markers:true,
                fastScrollEnd:true,
                preventOverlaps:true,
                onToggle: self => {
                    if(self.isActive){
                        _self.props.changeYear(6)
                    }
                    else{
                        _self.props.changeYear(null)
                    }
                }
            }
        });

        let t2009_ =  gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_para_2009'],
                start: "top bottom", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'top top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                fastScrollEnd:true,
                preventOverlaps:true,
            }
        });
        t2009_.to('.'+app_cs['background-image-2009-1'],{opacity:1,duration:2})
            .to('.'+app_cs['background-image-2008-1'],{opacity:0,duration:0});

        let t2013 = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_time_wrapper_7'],
                start: "top top", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'bottom top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                // markers:true,
                fastScrollEnd:true,
                preventOverlaps:true,
                onToggle: self => {
                    if(self.isActive){
                        _self.props.changeYear(7)
                    }
                    else{
                        _self.props.changeYear(null)
                    }
                }
            }
        });

        let t2013_ =  gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_para_2013'],
                start: "top bottom", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'top top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                fastScrollEnd:true,
                preventOverlaps:true,
            }
        });
        t2013_.to('.'+app_cs['background-image-2013-1'],{opacity:1,duration:2})
            .to('.'+app_cs['background-image-2009-1'],{opacity:0,duration:0},);

        let t2014= gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_time_wrapper_8'],
                endTrigger:"."+app_cs['content_para_2014_3'],
                pin: "."+app_cs['content_time_wrapper_8'],   // pin the trigger element while active
                start: "top top", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'top top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                // markers:true,
                fastScrollEnd:true,
                preventOverlaps:true,
                onToggle: self => {
                    if(self.isActive){
                        _self.props.changeYear(8)
                    }
                    else{
                        _self.props.changeYear(null)
                    }
                }
            }
        });


        let t2014_img2= gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_para_2014_3'],
                start: "top bottom", // when the top of the trigger hits the top of the viewport
                end:'top top+=50%',
                // pin:true,
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                fastScrollEnd:true,
                preventOverlaps:true,
            }
        });
        t2014_img2.to('.'+app_cs['content_pic_2014'],{opacity:0,duration:1})
        t2014_img2.to('.'+app_cs['content_pic_2014_2'],{opacity:1,duration:1},"<")

        let t2014_ =  gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_para_2014'],
                start: "top bottom", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                endTrigger:'.'+app_cs['content_para_2014_3'],
                end:'top top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                fastScrollEnd:true,
                preventOverlaps:true,
            }
        });
        t2014_.to('.'+app_cs['background-image-2013-1'],{opacity:0,duration:2})
            .to('.'+app_cs['background-image-2014-1'],{opacity:1,duration:2},"<")
            .to('.'+app_cs['background-image-2014-1'],{opacity:1,duration:2})
            .to('.'+app_cs['background-image-2014-1'],{opacity:0,duration:2},)
            .to('.'+app_cs['background-image-2014-2'],{opacity:1,duration:2},"<");

        let t2019 = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_time_wrapper_9'],
                start: "top top", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'bottom top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                // markers:true,
                fastScrollEnd:true,
                preventOverlaps:true,
                onToggle: self => {
                    if(self.isActive){
                        _self.props.changeYear(9)
                    }
                    else{
                        _self.props.changeYear(null)
                    }
                }
            }
        });

        let t2019_ =  gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_para_2019'],
                start: "top bottom", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'top top',
                fastScrollEnd:true,
                preventOverlaps:true,
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar

            }
        });
        t2019_.to('.'+app_cs['background-image-2014-2'],{opacity:0,duration:2},)
            .to('.'+app_cs['background-image-2019-1'],{opacity:1,duration:2},"<");

        let t2022 = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_time_wrapper_10'],
                start: "top top+=10%", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'bottom top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                // markers:true,
                fastScrollEnd:true,
                preventOverlaps:true,
                onToggle: self => {
                    if(self.isActive){
                        _self.props.changeYear(10)
                    }
                    else{
                        _self.props.changeYear(null)
                    }
                }
            }
        });

        let t2022_ =  gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_para_2022'],
                start: "top bottom", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'top top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                fastScrollEnd:true,
                preventOverlaps:true,
            }
        });
        t2022_.to('.'+app_cs['background-image-2022-1'],{opacity:1,duration:2})
            .to('.'+app_cs['background-image-2019-1'],{opacity:0,duration:0});

    }

    render() {
        return (
            <section  className={app_cs['container']}>

                <div className={app_cs['infoWrapper']}>
                    <div className={app_cs['content_history_wrapper']} >
                        <div className={app_cs['background-image-history']}></div>

                        {/*<div className={app_cs['content_history_part1']} style={{height:'100vh'}}>*/}
                        {/*</div>*/}
                        <div className={app_cs['content_history_part2']} style={{height:'100vh'}}>
                            <div className={app_cs['content_history_point']}></div>

                            <div className={app_cs['content_history_middle_text']}>
                            乌克兰为何重要？<br/>
                            乌克兰地处东欧平原，其地理位置特殊，位于欧洲与俄罗斯地缘政治交汇处。土地面积仅次于俄罗斯，为欧洲第二大国。俄乌两国都曾是前苏联的加盟国。
                            </div>

                            <div className={app_cs['content_history_middle_info']+ ' '+ app_cs['content_history_middle_info1']}>
                                <img src={img_agriculture} className={app_cs['content_history_middle_img']}></img>
                            </div>

                            <div className={ app_cs['content_history_middle_arrow1']}></div>

                            <div className={app_cs['content_history_middle_info']+ ' '+ app_cs['content_history_middle_info2']}>
                                <img src={img_gas} className={app_cs['content_history_middle_img']}></img>
                                <img src={icon_gas} className={app_cs['content_history_middle_icon']}></img>
                            </div>

                            <div className={ app_cs['content_history_middle_arrow2']}></div>

                            <div className={app_cs['content_history_middle_info']+ ' '+ app_cs['content_history_middle_info3']}>
                                <img src={img_nuclear} className={app_cs['content_history_middle_img']}></img>
                                <img src={icon_nuclear} className={app_cs['content_history_middle_icon']}></img>
                            </div>
                            <div className={app_cs['content_history_middle_info']+ ' '+ app_cs['content_history_middle_info4']}>
                                <img src={img_money} className={app_cs['content_history_middle_img']}></img>
                                <img src={icon_money} className={app_cs['content_history_middle_icon_right']}></img>
                            </div>

                            <div className={app_cs['content_history_para']+ ' '+ app_cs['content_history_para1']} style={{top:'16.76vh',left:'11.51vw'}}>
                                <div className={app_cs['content_history_para_mark']} ></div>
                                <div className={app_cs['content_history_para_title']} >
                                欧洲“粮仓”
                                </div>
                                <div className={app_cs['content_history_description']} >
                                    <div className={app_cs['content_history_description_back']}></div>
                                    <div className={app_cs['content_history_description_content']}>
                                        <p>乌克兰拥有地球四分之一的黑土地，且全国71%的土地为耕地。乌克兰是世界第四大玉米出口国及第五大小麦出口国。2020年葵花籽油出口量位居全球首位，占世界葵花籽油出口量总数的40%。</p>
                                    </div>
                                </div>
                            </div>

                            <div className={app_cs['content_history_para']+ ' '+ app_cs['content_history_para2']} style={{top:'11.203vh',left:'56.98vw'}}>
                                <div className={app_cs['content_history_para_mark']} ></div>
                                <div className={app_cs['content_history_para_title']} >
                                欧洲“气管”
                                </div>
                                <div className={app_cs['content_history_description']} >
                                    <div className={app_cs['content_history_description_back']}></div>
                                    <div className={app_cs['content_history_description_content']}>
                                        <p>乌克兰拥有重要的俄欧天然气运输管道。2021年，416亿立方米的俄罗斯天然气经乌克兰运送至欧洲，占欧洲从俄罗斯进口天然气总量的26.8%。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className={app_cs['content_history_para']+ ' '+ app_cs['content_history_para3']} style={{top:'55.93vh',left:'19.22vw'}}>
                                <div className={app_cs['content_history_para_mark']} ></div>
                                <div className={app_cs['content_history_para_title']} >
                                欧洲“核心”
                                </div>
                                <div className={app_cs['content_history_description']} >
                                    <div className={app_cs['content_history_description_back']}></div>
                                    <div className={app_cs['content_history_description_content']}>
                                        <p>乌克兰共有四座核电站，皆为苏联时期所造。其中，扎波罗热核电站为欧洲最大核电站。2020年，乌克兰的核电发电量为76202吉瓦时，位居世界第七。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className={app_cs['content_history_para']+ ' '+ app_cs['content_history_para4']} style={{top:'51.02vh',left:'62.60vw'}}>
                                <div className={app_cs['content_history_para_mark']} ></div>
                                <div className={app_cs['content_history_para_title']} >
                                与北约的“特殊关系”
                                </div>
                                <div className={app_cs['content_history_description']} >
                                    <div className={app_cs['content_history_description_back']}></div>
                                    <div className={app_cs['content_history_description_content']}>
                                        <p>
                                            {/* Ukraine-NATO relations started in the early 1990s soon after the country's independence from the USSR. Ukraine is also <span className={app_cs['importantDesc']}>one of the leading recipients from NATO members</span>. From 2014 to 2021, Ukraine received more than $2.5 billion in military aid from the U.S. */}
                                            乌克兰与北约的关系始于苏联解体。<span className={app_cs['importantDesc']}>虽然乌克兰未正式加入北约，但以美国为首的北约国家却一直为乌克兰提供军事援助。</span>从2014年到2021年，乌克兰从美国获得了超过25亿美元的军事援助。
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className={app_cs['content_history_part_empty']} style={{height:'100vh'}}></div>
                        <div className={app_cs['history-timeline']}></div>
                    </div>
                    <div className={app_cs['info']}>
                        <div className={app_cs['background']}>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-1991-1']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-1991-2']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-1991-3']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-1991-4']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-1994-1']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-1999-1']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-1999-font']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-1999-2']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-2004-1']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-2008-1']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-2009-1']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-2013-1']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-2014-1']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-2014-2']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-2019-1']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-2022-1']}></div>
                        </div>
                        <div className={app_cs['content_wrapper']} >
                            <div className={app_cs['content_left']}>
                                {/* start 1991 */}
                                <div style={{height:'100vh'}}></div>
                                <div className={app_cs['content_para_1991']} style={{paddingTop:'25.37vh'}}>
                                    <div className={app_cs['content_para_title']}>
                                        乌克兰独立
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p>1991年8月24日，乌克兰政府发表《乌克兰独立宣言》，正式宣布脱离苏联独立。</p>
                                            <p>12月26日，苏联最高苏维埃共和国院举行最后一次会议，宣布苏联停止存在。前苏联解体为15个国家：俄罗斯，乌克兰，白俄罗斯，摩尔多瓦，格鲁吉亚，亚美尼亚，阿塞拜疆，塔吉克斯坦，吉尔吉斯斯坦，哈萨克斯坦，土库曼斯坦，乌兹别克斯坦，立陶宛，拉脱维亚和爱沙尼亚。</p>

                                            <p>独立后的乌克兰东北部与俄罗斯接壤，北临白俄罗斯，而其西部接壤的波兰、匈牙利、斯洛伐克及南部的罗马尼亚都在此后十几年间先后加入了“西方阵营”——北约。</p>

                                        </div>
                                    </div>
                                </div>
                                <div className={app_cs['content_para_1991_2']} style={{marginTop:'74.63vh',paddingTop:'45%'}}>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p><span className={app_cs['importantBold']} >什么是北约？</span><br/>
                                             {/* The North Atlantic Treaty Organization was created in 1949 by the  <span className={app_cs['importantDesc']} >U.S., Canada and several Western European nations. </span>
                                                The military alliance now includes  <span className={app_cs['importantDesc']} >30 countries. </span> */}
                                                北大西洋公约组织（简称北约），是<span className={app_cs['importantDesc']}>是由美国、英国、法国、加拿大等西方国家在1949年建立的军事联盟。现已有30个成员国。</span>
                                            </p>
                                            <p>冷战时期，北约的根本目的是抗衡苏联领导的华沙条约组织。后冷战时代，北约以向盟国提供“绝对安全保障”为由，持续东扩。这一超级军事集团不仅对世界和平没有发挥积极作用，相反，世界大部分冲突和紧张的局势都与它有关，包括科索沃战争、阿富汗战争、伊拉克战争和利比亚战争。</p>
                                            <span>（此处地图展示时期为1990年10月3日至1991年6月25日）</span>
                                        </div>
                                    </div>
                                </div>
                                <div className={app_cs['content_para_1991_3']} style={{marginTop:'74.63vh',paddingTop:'25.37vh'}}>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p> <span className={app_cs['importantBold']} >什么是华约？ </span><br/> 1955年，旨在对抗北约势力的华沙条约组织（简称华约）成立。华约由苏联及其他七个欧洲社会主义阵营国家组成。华约与北约分别代表了东西方不同的意识形态，针锋相对。</p>
                                        </div>
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p>
                                            1990年，东德与西德完成统一，东德随即退出华约，并加入了北约，成为第一个加入北约的华约成员国。
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className={app_cs['content_para_1991_4']} style={{marginTop:'74.63vh',paddingTop:'45%'}}>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p>1991年7月1日，华约正式解散。
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* end 1991 */}

                                {/* start 1994 */}

                                <div className={app_cs['content_para_1994']} style={{marginTop:'100vh',paddingTop:'25.37vh'}}>
                                    <div className={app_cs['content_para_title']}>
                                        {/* Budapest<br/>
                                        Memorandum */}
                                        布达佩斯<br />安全保障备忘录
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p> 作为苏联时期重要的军事工业中心，独立的乌克兰继承了一笔可观的苏联核遗产——约1900枚核弹头。这使乌克兰成为了当时核武器储备第三大国，仅在美俄之后。同为前苏联加盟国的白俄罗斯和哈萨克斯坦也继承了苏联庞大的核遗产。于是，在力主三国弃核的问题上，美俄达成了共识。</p>

                                            <p> 1994年12月5日，美国、俄罗斯、英国、乌克兰、白俄罗斯、哈萨克斯坦六国于匈牙利首都布达佩斯签署了《布达佩斯安全保障备忘录》。美、俄、英承诺为乌、白、哈提供安全保障，但作为交换，三国需放弃并销毁自己所有的核武器。美、俄、英同时承诺不会对乌克兰使用武力或经济胁迫。
                                            </p>

                                            <p>同月，北约在布鲁塞尔举行的北约外长会议上开始公开讨论其向东扩张的议题，俄罗斯总统叶利钦怒不可遏，并在签订布达佩斯备忘录的当天，指责“霸道”的美国通过北约扩张“试图再次分裂欧亚大陆”。</p>
                                        </div>
                                    </div>
                                </div>

                                {/* end 1994 */}
                                {/* start 1999 */}
                                <div className={app_cs['content_para_1999']} style={{marginTop:'100vh',paddingTop:'25.37vh'}}>
                                    <div className={app_cs['content_para_title']}>
                                        北约首次东扩：
                                        <br />
                                        前华约三国加入北约
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p> 1999年1月，北约向前华约国家波兰、匈牙利和捷克发出邀请。在北约内部的激烈争论和俄罗斯的强烈反对下，三国于3月12日正式签署加入北约协定，这是北约势力在冷战后的第一次扩张。
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className={app_cs['content_para_1999_2']} style={{marginTop:'100vh',paddingTop:'25.37vh'}}>


                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p>同月，北约在科索沃战争期间对前南斯拉夫联盟共和国进行了大规模空袭轰炸。这让俄罗斯反思“与西方保持友好关系的尝试可能是一个错误”。</p>
                                            <p>前南斯拉夫外交官维斯科·加塞维奇指出，北约在未经联合国批准的情况下单方面轰炸南联盟的决定标志着俄罗斯与西方关系的转折点。</p>
                                        </div>
                                    </div>
                                </div>
                                {/* end 1999 */}

                                {/* start 2004 */}

                                <div className={app_cs['content_para_2004']} style={{marginTop:'100vh',paddingTop:'8.93vh'}}>
                                    <div className={app_cs['content_para_title']}>
                                        {/* Baltic states<br/>
                                        join NATO */}
                                        北约再次东扩：<br/>波罗的海三国加入北约
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p>
                                            2004年3月29日，北约迎来了七个新成员：保加利亚、罗马尼亚、斯洛伐克、斯洛文尼亚，以及波罗的海三国——爱沙尼亚、拉脱维亚和立陶宛。 </p>

                                            <p>18世纪末到20世纪初，波罗的海三国曾是沙俄版图的一部分。这三个国家的海岸线极大地拓宽了俄罗斯的出海口，无论在贸易或军事上均具有重要战略意义。自古以来，欧洲各国为在波罗的海称雄，屡次发动战争。</p>

                                            {/* <p> Initially, the idea of the Baltic nations joining NATO was not well-received by U.S. policymakers, because of the countries' deep historical ties with Russia. But the Baltic states went out of their way to appeal to the West. After gaining independence in 1991, these countries were determined to join NATO and the European Union and went through political and economic reforms to meet the entry requirements. <span className={app_cs['importantDesc']}>In 2004, they became the first post-Soviet states to join NATO. </span></p> */}

                                            <p> 由于波罗的海三国与俄罗斯之间深厚的历史渊源，美国起初并未接受三国加入北约。但三国为了加盟入约，自1991年独立后，就迅速进行了一系列政治和经济改革以满足北约的要求。<span className={app_cs['importantDesc']}> 2004年，它们成为了第一批加入北约的前苏联国家。</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* end 2004 */}

                                {/* start 2008 */}

                                <div className={app_cs['content_para_2008']} style={{marginTop:'100vh',paddingTop:'23.01vh'}}>
                                    <div className={app_cs['content_para_title']}>
                                        {/* Ukraine asks for <br/>
                                        membership */}
                                        北约东扩仍在继续： <br/>乌克兰申请加入
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p> 2008年3月，在乌克兰总统维克托·尤先科和总理季莫申科的领导下，乌克兰正式申请加入北约“成员国行动计划”（Membership Action Plan），该行动计划被认为是“加入北约的第一步”，即成为“北约发展对象”。</p>

                                            <p> 4月，在布加勒斯特举行的北约峰会就是否准许乌克兰加入北约展开了激烈辩论。俄罗斯总统普京受邀前往。</p>
                                            <p>美国前总统布什和波兰前总统卡钦斯基大力支持乌克兰加入北约，同时，也有反对的声音。除俄罗斯外，英、法、德三国都不赞成乌克兰的加入。最终，乌克兰未能在此次峰会获得成员资格。然而，北约秘书长夏侯雅伯承诺，乌克兰加入北约的大门总有一天会敞开。</p>
                                            <p>在这次峰会上，北约称在成员国部署的导弹防御系统并非针对俄罗斯，但普京回应称此类说法不会缓解俄罗斯的担忧：“国家安全不是基于承诺，在北约前几次扩张前发表的声明都证实了这一点。”</p>
                                        </div>
                                    </div>
                                </div>

                                {/* end 2008 */}


                                {/* start 2009 */}

                                <div className={app_cs['content_para_2009']} style={{marginTop:'100vh',paddingTop:'23.01vh'}}>
                                    <div className={app_cs['content_para_title']}>
                                    阿尔巴尼亚和克罗地亚<br/>
                                        加入北约
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p>
                                            2009年，阿尔巴尼亚和克罗地亚成为北约扩张的新成员。随着阿尔巴尼亚的加入，大多数前华约国家至此都加入了北约。
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* end 2009 */}

                                {/* start 2013 */}

                                <div className={app_cs['content_para_2013']} style={{marginTop:'100vh',paddingTop:'23.01vh'}}>
                                    <div className={app_cs['content_para_title']}>
                                    乌克兰反政府示威
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p>2013年11月，乌克兰总统亚努科维奇暂停了与欧盟签订联系国协定，转而寻求与俄罗斯建立更密切的关系，这一决定在乌克兰首都基辅引发了一波又一波的抗议。骚乱在2014年2月升级并达到高潮，抗议者和警察之间的武力冲突造成多起死伤。</p>

                                            <p>2014年2月21日，为了结束动荡，亚努科维奇和议会反对党领袖签署了一项协议，将在12月之前组建联合政府、进行宪法改革和重新举行总统选举。但第二天，亚努科维奇即被议会集体投票赶下台。</p>

                                            <p>3月11日，乌克兰克里米亚自治共和国通过决议，批准关于该共和国和塞瓦斯托波尔市独立的宣言。</p>
                                        </div>
                                    </div>
                                </div>

                                {/* end 2013 */}

                                {/* start 2014 */}
                                <div className={app_cs['content_para_2014']} style={{marginTop:'100vh',paddingTop:'25.37vh'}}>
                                    <div className={app_cs['content_para_title']}>
                                    克里米亚危机
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p>2014年3月16日，克里米亚自治共和国议会决定举行关于共和国地位的全民公投：独立并加入俄罗斯还是继续作为乌克兰的一部分。百分之九十七的人投票加入俄罗斯。随后的第68届联合国大会投票通过有关乌克兰问题决议，申明16日在克里米亚自治共和国和塞瓦斯托波尔市举行的全民公投“无效”，“不能成为改变克里米亚自治共和国和塞瓦斯托波尔市地位的基础”。美、英、法等100个国家投赞成票，俄罗斯、古巴等11个国家投票反对，中国、巴西、印度等58个国家弃权。</p>

                                            <p>克里米亚独立公投后，克里米亚共和国成立，并于3月18日加入俄罗斯，与塞瓦斯托波尔市共同组成克里米亚联邦区。乌克兰政府并不承认这次公投。4月15日，乌克兰议会宣布克里米亚是被俄罗斯“暂时占领的领土”。北约对乌克兰表示支持，称公投“直接违反了乌克兰宪法和国际法”。</p>
                                        </div>
                                    </div>
                                </div>
                                <div className={app_cs['content_para_2014_3']} style={{marginTop:'100vh',paddingTop:'25.37vh'}}>
                                    <div className={app_cs['content_para_title']}>
                                        {/* Uprisings<br/> in eastern Ukraine */}
                                        乌东再现 <br/>“克里米亚危机”
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p>
                                            同年5月，乌克兰东部顿巴斯地区，亲俄民间武装势力亦爆发与政府军之间的冲突，随后宣布从乌克兰“独立”，自立“顿涅茨克人民共和国”和“卢甘斯克人民共和国”。 </p>

                                            <p>2015年2月，俄罗斯、乌克兰、欧洲安全与合作组织（欧安组织）的代表以及顿涅茨克和卢甘斯克地区的领导人在白俄罗斯首都明斯克签署了和平协议。但俄乌双方对协议的解释截然不同，因此该协议最终未能在乌克兰东部实现停火。
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                {/* end 2014 */}

                                {/* start 2019 */}

                                <div className={app_cs['content_para_2019']} style={{marginTop:'100vh',paddingTop:'6.39vh'}}>
                                    <div className={app_cs['content_para_title']}>
                                    泽连斯基当选
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p> 2019年，乌克兰著名演员泽连斯基在大选中以压倒性优势战胜了时任总统波罗申科，赢得超70%的选票，并于5月20日正式就任乌克兰第六任总统。</p>

                                            <p><span className={app_cs['importantDesc']} ></span>
                                            泽连斯基在竞选中曾承诺将缓和与俄罗斯的紧张关系，并结束乌克兰东部持续多年的武装冲突。但是过去几年里，乌克兰与北约的关系进一步加深，这也导致俄乌关系的持续恶化。<span className={app_cs['importantDesc']}>2020年6月，乌克兰与澳大利亚、芬兰、格鲁吉亚、约旦和瑞典获得了北约“增强伙伴国”地位。</span>北约声称这一新地位并不能“预判”乌克兰的正式加入，但表示“乌克兰将继续在安全和国防领域获得北约盟国的支持”。
                                            </p>

                                            <p> 2021年，乌克兰三家电视台因“传播俄罗斯的虚假信息”而被停播。普京对此回应称，乌克兰正在走向“俄罗斯的对立面”，俄罗斯需要“从安全角度引起重视”。</p>

                                            <p>2021年底，俄罗斯向北约提出诉求并划下“安全红线”，提出不允许北约进一步东扩、不允许部署威胁俄联邦领土安全的打击性武器的明确立场。但美国和北约的答复未解决俄罗斯的核心关切，继续坚持北约的“门户开放政策”。</p>

                                        </div>
                                    </div>
                                </div>

                                {/* end 2019 */}

                                {/* start 2022 */}

                                <div className={app_cs['content_para_2022']} style={{marginTop:'100vh',paddingTop:'23.01vh'}}>
                                    <div className={app_cs['content_para_title']}>
                                    普京承认 <br/>乌东两个“共和国”
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p>2022年2月22日，普京承认乌克兰东部“顿涅茨克人民共和国”和“卢甘斯克人民共和国”为独立的主权国家。乌克兰称此举侵犯其国家主权。24日，普京在电视讲话中宣布将开始一项“特别军事行动”，使乌克兰“去军事化”和“去纳粹化”。普京称，“行动”的目的并不包括占领乌克兰领土。同日，俄罗斯军方对乌克兰境内的数十个军事目标发动进攻。</p>
                                        </div>
                                    </div>
                                </div>

                                {/* end 2022 */}

                            </div>

                            <div className={app_cs['content_right']}>
                                <div className={app_cs['content_time_wrapper']+' '+app_cs['content_time_wrapper_1'] }>
                                    <div className={app_cs['content_time']}>1991</div>
                                    <div className={app_cs['content_point']}></div>
                                </div>

                                <div style={{marginTop:'100vh'}} className={app_cs['content_time_wrapper']+' '+app_cs['content_time_wrapper_2'] }>
                                    <div className={app_cs['content_time']}>1994</div>
                                    <div className={app_cs['content_point']}></div>
                                    <div className={app_cs['content_pic']+' '+app_cs['content_pic_1994'] } ></div>
                                </div>
                                <div style={{marginTop:'100vh'}} className={app_cs['content_time_wrapper']+' '+app_cs['content_time_wrapper_3'] }>
                                    <div className={app_cs['content_time']}>1999</div>
                                    <div className={app_cs['content_point']}></div>
                                    <div className={app_cs['content_pic']+' '+app_cs['content_pic_1999'] } ></div>
                                </div>
                                <div style={{marginTop:'100vh'}} className={app_cs['content_time_wrapper']+' '+app_cs['content_time_wrapper_4'] }>
                                    <div className={app_cs['content_time']}>2004</div>
                                    <div className={app_cs['content_point']}></div>
                                </div>
                                <div style={{marginTop:'100vh'}} className={app_cs['content_time_wrapper']+' '+app_cs['content_time_wrapper_5'] }>
                                    <div className={app_cs['content_time']}>2008</div>
                                    <div className={app_cs['content_point']}></div>
                                    <div className={app_cs['content_pic']+' '+app_cs['content_pic_2008'] } ></div>
                                </div>
                                <div style={{marginTop:'100vh'}} className={app_cs['content_time_wrapper']+' '+app_cs['content_time_wrapper_6'] }>
                                    <div className={app_cs['content_time']}>2009</div>
                                    <div className={app_cs['content_point']}></div>
                                </div>
                                <div style={{marginTop:'100vh'}} className={app_cs['content_time_wrapper']+' '+app_cs['content_time_wrapper_7'] }>
                                    <div className={app_cs['content_time']}>2013</div>
                                    <div className={app_cs['content_point']}></div>
                                    <div className={app_cs['content_pic']+' '+app_cs['content_pic_2013'] } ></div>
                                </div>
                                <div style={{marginTop:'100vh'}} className={app_cs['content_time_wrapper']+' '+app_cs['content_time_wrapper_8'] }>
                                    <div className={app_cs['content_time']}>2014</div>
                                    <div className={app_cs['content_point']}></div>
                                    <div className={app_cs['content_pic_wrapper']}>
                                        <div className={app_cs['content_pic_2014'] } ></div>
                                        <div className={app_cs['content_pic_2014_2'] } ></div>
                                    </div>

                                </div>
                                <div style={{marginTop:'100vh'}} className={app_cs['content_time_wrapper']+' '+app_cs['content_time_wrapper_9'] }>
                                    <div className={app_cs['content_time']}>2019</div>
                                    <div className={app_cs['content_point']}></div>
                                    <div className={app_cs['content_pic']+' '+app_cs['content_pic_2019'] } ></div>
                                </div>
                                <div style={{marginTop:'100vh'}} className={app_cs['content_time_wrapper']+' '+app_cs['content_time_wrapper_10'] }>
                                    <div className={app_cs['content_time']}>2022</div>
                                    <div className={app_cs['content_point']}></div>
                                    <div className={app_cs['content_pic']+' '+app_cs['content_pic_2022'] } ></div>

                                    <div className={app_cs['copyright']}>
                                        <div className={app_cs['copyright_text']}>本产品内所有地图仅作示意使用<br/>
                                            Copyright © 2022 CGTN All Rights Reserved.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>)
    }
}

export default App;